var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDash = function SvgIconDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 1
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M.322.892Q0 .892 0 .486 0 .108.322.108h13.356q.322 0 .322.378 0 .406-.322.406z"
  })));
};
export { SvgIconDash as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMSIgdmlld0JveD0iMCAwIDE0IDEiIGZpbGw9IiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzIyIDAuODkyQzAuMTA3MzMzIDAuODkyIDAgMC43NTY2NjYgMCAwLjQ4NkMwIDAuMjM0IDAuMTA3MzMzIDAuMTA4IDAuMzIyIDAuMTA4SDEzLjY3OEMxMy44OTI3CiAwLjEwOCAxNCAwLjIzNCAxNCAwLjQ4NkMxNCAwLjc1NjY2NiAxMy44OTI3IDAuODkyIDEzLjY3OCAwLjg5MkgwLjMyMloiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";